'use client';

import Link from 'next/link';
import { convertObjectToQueryParam } from 'utils/misc';
import { IconClose, Button } from '@sympla/sympla-components';
import locationStore from 'stores/LocationStore';
import { Location } from 'location';

import { useLastSearches } from 'hooks/useLastSearches';
import { createLinkToRedirect } from 'utils/createLinkToRedirect';
import * as styles from './RecentSearches.css';

const generateSearchLink = (text: string, userLocation: Location) => {
  const query = convertObjectToQueryParam({ s: text });
  return createLinkToRedirect({
    param: query,
    routeType: 'search-bar-default-filter',
    userLocation
  });
};

function RecentSearches({ hasMossColor }: { hasMossColor: boolean }) {
  const { updateLastSearches, lastSearches, removeLastSearch } =
    useLastSearches();

  const userLocation = locationStore.selectedLocation;

  const handleRemoveSearch = (text: string) => {
    removeLastSearch(text);
  };

  const handleUpdateLastSearches = (text: string) => {
    updateLastSearches(text);
  };

  const currentLinkStyle = `${styles.linkStyle} ${
    hasMossColor ? styles.linkStyleMoss : ''
  }`;

  const currentIconStyle = `${styles.iconStyle} ${
    hasMossColor ? styles.iconStyleMoss : ''
  }`;

  const lastSearchesItems = lastSearches?.map((text) => {
    return (
      <li key={text} className={styles.searchItem}>
        <Link
          onClick={() => handleUpdateLastSearches(text)}
          className={currentLinkStyle}
          href={generateSearchLink(text, userLocation)}
        >
          {text}
        </Link>
        <Button
          variant="text"
          className={styles.linkStyle}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleRemoveSearch(text);
          }}
          aria-label={`Remover busca recente: ${text}`}
        >
          <IconClose width={14} height={14} className={currentIconStyle} />
        </Button>
      </li>
    );
  });

  return (
    lastSearches &&
    lastSearches.length > 0 && (
      <div className={styles.lastSearchesContainer}>
        <h3 className={styles.sectionTitle}>Busca recente</h3>
        <ul className={styles.lastSearchItems}>{lastSearchesItems}</ul>
      </div>
    )
  );
}

export default RecentSearches;
